import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Typography, Popconfirm, message } from 'antd';
import type { TableProps } from 'antd';
import SPButton from 'components/carRental/base/SPButton';

import emiter, {
  EVENT_CARRENTAL_BRANCH_MODAL_OPEN,
  EVENT_CARRENTAL_BRANCH_ADD,
  EVENT_CARRENTAL_UPDATE_WEBSITE_LIST,
  EVENT_CARRENTAL_BRANCH_VIEW,
} from '../../../../events';

import { getStoreWebsiteList, updateWebsiteStatus } from 'hooks/carRental/store';
import EnumKeyToText from "../../../product-price/base/EnumKeyToText";

const { Text } = Typography;

const DEFAULT_PAGE_SIZE = 10;

interface PropsType {
  enums?: any;
  permission?: any;
}

const SPBranchManagementModal: React.FC<PropsType> = (props) => {
  const { permission, enums } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dayoffList, setDayoffList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [storeInfo, setStoreInfo] = useState<any>({});
  const [currentPageData, setCurrentPageData] = useState<any>({ pageIndex: 1, pageSize: DEFAULT_PAGE_SIZE });

  const BusinessTimeActionBar = (props: any) => (<>{`${props.openTime}-${props.endTime}`}</>);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleModelOpen = (info: any) => {
    showModal();
    setStoreInfo(info);
  }

  const handleRelevanceSet = (record: any) => {
    updateWebsiteStatus({
      website_code: record?.website_code,
      store_code: storeInfo?.store_code,
    }).then((res: any) => {
      const { errno } = res || {};
      if (errno === 0) {
        message.success('操作成功');
        getWebsiteList(currentPageData);
      }
    });
  }

  const handleBranchAdd = () => {
    emiter.emit(EVENT_CARRENTAL_BRANCH_ADD, storeInfo);
  }

  const handleView = (record: any) => {
    emiter.emit(EVENT_CARRENTAL_BRANCH_VIEW, storeInfo, record);
  }

  const handleEdit = (record: any) => {
    emiter.emit(EVENT_CARRENTAL_BRANCH_ADD, storeInfo, record);
  }


  const columns: TableProps<any>['columns'] = [
    {
      title: '网点名称',
      dataIndex: 'website_name',
      key: 'name',
    },
    {
      title: '网点地址',
      dataIndex: 'address',
      key: 'create_time',
    },
    // {
    //   title: '提前预定时间',
    //   dataIndex: 'status',
    //   key: 'status',
    // },
    {
      title: '营业时间',
      dataIndex: 'create_time',
      key: 'name',
      render: (_, record) => <BusinessTimeActionBar openTime={record.open_time} endTime={record.end_time} />
    },
    {
      title: '门店网点距离',
      dataIndex: 'store_distance',
      key: 'store_distance',
    },
    {
      title: '审核状态',
      dataIndex: 'store_status',
      width: 100,
      render: (_, record) => <EnumKeyToText data={record} enums={enums} valueKey={'audit_status'} nameSpace={'audit_status'} />,
    },
    {
      title: '上架状态',
      dataIndex: 'store_status',
      width: 100,
      render: (_, record) => <EnumKeyToText data={record} enums={enums} valueKey={'status'} nameSpace={'store_status'} />,
    },
    {
      title: '操作',
      key: 'action',
      fixed: true,
      render: (_, record) => (
        <>
          <SPButton permission={permission} permissionKey='store_website_update' type="link" onClick={() => handleEdit(record)}>编辑</SPButton>
          <SPButton permission={permission} permissionKey='store_website_detail' type="link" onClick={() => handleView(record)}>查看</SPButton>
          {/*<SPButton permission={permission} permissionKey='store_website_update_status' type="link">{ record.status === 1 ? '上架' : '下架' }</SPButton>*/}
          <Popconfirm
            title={ `确定${record.status === 1 ? '下架' : '上架'}吗` }
            onConfirm={() => handleRelevanceSet(record)}
            okText="确定"
            cancelText="取消"
          >
            <SPButton permission={permission} permissionKey='store_website_update_status' type="link">{ record.status === 1 ? '下架' : '上架' }</SPButton>
          </Popconfirm>
        </>
      ),
    },
  ];

  const getWebsiteList = (data: any) => {
    const { pageIndex, pageSize, code } = data || {};
    setCurrentPageData({pageIndex: pageIndex || 1, pageSize: pageSize || DEFAULT_PAGE_SIZE});
    getStoreWebsiteList({
      page: pageIndex,
      page_size :pageSize,
      store_code: code || storeInfo?.store_code,
      audit_status: -1
    }).then((res: any) => {
      const { data } = res || {};
      const { list, total } = data || {};
      setDayoffList(list);
      setTotalCount(total);
    });
  }

  const onPaginationChange = (data: any) => {
    const { current, pageSize } = data || {};
    const pageInfo = { pageIndex: current, pageSize };
    setCurrentPageData(pageInfo);
    getWebsiteList(pageInfo);
  }

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_BRANCH_MODAL_OPEN, handleModelOpen);
    emiter.on(EVENT_CARRENTAL_UPDATE_WEBSITE_LIST, (code) => getWebsiteList({
      pageIndex: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      code,
    }));
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_BRANCH_MODAL_OPEN)
      emiter.removeAllListeners(EVENT_CARRENTAL_UPDATE_WEBSITE_LIST)
    }
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      getWebsiteList({});
    }
  }, [isModalOpen]);


  return (
    <Modal
      title="门店网点管理"
      width={900}
      open={isModalOpen}
      onOk={handleCancel}
      onCancel={handleCancel}
      okText="关闭"
      cancelButtonProps={{style: { display: 'none' }}}
    >
      <SPButton permission={permission} type="primary" permissionKey='store_website_add' style={{ marginBottom: '12px' }} onClick={handleBranchAdd}>新增关联网点</SPButton>
      {/*<Text type="secondary" style={{ marginBottom: '12px', display: 'block' }}>*/}
      {/*  为保障运营效率单门最多关联100网点，网点之间最小距离为3公里*/}
      {/*</Text>*/}
      <Table
        scroll={{ x: true }}
        columns={columns}
        dataSource={dayoffList}
        rowKey={row => row.id}
        pagination={{
          total: totalCount,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal:total => `共 ${total} 条数据`,
          current:currentPageData?.pageIndex,
          pageSize:currentPageData?.pageSize
        }}
        onChange={onPaginationChange}
      />
    </Modal>
  )
}

export default SPBranchManagementModal;
